import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Terms from "../pages/Terms/page";
import Privacy from "../pages/Privacy/page";
import Disclaimer from "../pages/Disclaimer/page";
import Contact from "../pages/Contact/page";
import Unsubscribe from "../pages/Unsubscribe/page";
import BlogPage from "../pages/Blog/page";
import BlogPostPage from "../pages/Blog/components/BlogPostPage";
import BlogAdminPage from "../pages/BlogAdmin/page";
import KnowledgePage from "../pages/knowledge/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/knowledge",
    element: <KnowledgePage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/admin",
    element: <BlogAdminPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPostPage />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/disclaimer",
    element: <Disclaimer />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/unsubscribe",
    element: <Unsubscribe />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;